<div *ngIf="shouldDisplay()"
     class="agent-temperature layout-row layout-align-start-center gap-5"
     (click)="$event.stopPropagation();">

  <ng-container *ngFor="let sensor of sensorsData">
    <div class="sensor-item layout-row layout-align-start-center"
         [ngClass]="getSensorStatus(sensor)"
         [ngbTooltip]="temperatureTooltip"
         (mouseenter)="setActiveSensor(sensor)"
         openDelay="300"
         triggers="hover"
         container="body">

      <bringoz-icon iconName="thermometer"
                    [fill]="getSensorColor(sensor)"
                    classSize="lg">
      </bringoz-icon>

      <!-- Temperature Value using pipe -->
      <span class="temperature-value margin-left-5 br-body-2">
        {{ sensor.data.temperature | bringozTemperature }}
      </span>
    </div>
  </ng-container>

</div>

<!-- Temperature Tooltip Template -->
<ng-template #temperatureTooltip>
  <div *ngIf="activeSensor" class="temperature-tooltip layout-column layout-align-start-start br-body-2 font-weight-400 primary-100">

    <!-- Sensor Name -->
    <div class="layout-row layout-align-start-center margin-bottom-5">
      <span>{{ activeSensor.sensorName }}</span>
    </div>

    <!-- Threshold -->
    <div *ngIf="activeSensor.data.minThreshold != null && activeSensor.data.maxThreshold != null"
         class="layout-row layout-align-start-center margin-bottom-5">
      <span translate>Threshold</span>
      <span class="margin-left-5">({{ activeSensor.data.minThreshold | bringozTemperature }} > {{ activeSensor.data.maxThreshold | bringozTemperature }})</span>
    </div>

    <!-- Last Update -->
    <div *ngIf="activeSensor.updatedTime"
         class="layout-row layout-align-start-center">
      <span translate>Last update</span>
      <span class="margin-left-5">{{ getLastUpdate(activeSensor) }}</span>
    </div>

  </div>
</ng-template>
